import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { AuthService } from '@appCore/services/auth.service';

// AUTH - AuthGuard

@Injectable({
    providedIn: 'root'
})
export class AuthGuard {
    constructor(private authService: AuthService, private router: Router) {}

    canActivate(): boolean {
        const isLoggedIn = this.authService.isAuthenticated();
        if (isLoggedIn) {
            return true;
        } else {
            this.router.navigate(['/login']);
            return false;
        }
    }
}
